import { generator } from '../event-listener.js';
export const onAbort = generator('onAbort');
export const onCompleted = generator('onCompleted');
export const onError = generator('onError');
export const onInvalid = generator('onInvalid');
export const onPreview = generator('onPreview');
export const onRemove = generator('onRemove');
export const onRetry = generator('onRetry');
export const onUpload = generator('onUpload');
//# sourceMappingURL=transferable.js.map